import script from "./PlayerComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayerComponent.vue?vue&type=script&setup=true&lang=js"

import "./PlayerComponent.vue?vue&type=style&index=0&id=6cccd0ef&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cccd0ef"]])

export default __exports__